import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtml',
})
export class RemoveHtmlPipe implements PipeTransform {
  transform(value: string): string {
    return (
      value
        ?.replace(/<[^>]*>/gi, '')   // complete tags
        ?.replace(/<[^>]*$/gi, '')   // dangling/truncated tag at end of string
        ?.replace(/&nbsp;|\u00A0|\uFEFF/g, ' ') // html entities + zero-width chars from Quill mentions
        ?.replace(/\s+/g, ' ')
        ?.trim() ?? ''
    );
  }
}
